import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const WelcomePage = lazy(() => import("@/pages/welcome/page"));
const HomePage = lazy(() => import("@/pages/home/page"));
const LoginPage = lazy(() => import("@/pages/login/page"));
const IndividualBookingPage = lazy(() => import("@/pages/booking/individual/page"));
const GroupBookingPage = lazy(() => import("@/pages/booking/group/page"));
const FieldsPage = lazy(() => import("@/pages/fields/page"));
const MyBookingsPage = lazy(() => import("@/pages/my-bookings/page"));
const WalletPage = lazy(() => import("@/pages/wallet/page"));
const StatisticsPage = lazy(() => import("@/pages/statistics/page"));
const ProfilePage = lazy(() => import("@/pages/profile/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <WelcomePage />,
  },
  {
    path: "/home",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/booking/individual",
    element: <IndividualBookingPage />,
  },
  {
    path: "/booking/group",
    element: <GroupBookingPage />,
  },
  {
    path: "/fields",
    element: <FieldsPage />,
  },
  {
    path: "/my-bookings",
    element: <MyBookingsPage />,
  },
  {
    path: "/wallet",
    element: <WalletPage />,
  },
  {
    path: "/statistics",
    element: <StatisticsPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
